import { render } from "./timer.vue?vue&type=template&id=a432f070&ts=true"
import script from "./timer.vue?vue&type=script&lang=ts"
export * from "./timer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__